import React, { useState, useRef, useEffect } from "react";
import logo from "../Assets/logo.png";
import Select from "react-tailwindcss-select";
import { MultiSelect } from "react-multi-select-component";
import ReactSignatureCanvas from "react-signature-canvas";
import { MdCheckCircle, MdError } from "react-icons/md";
import { db } from "../firebase";
import { collection, addDoc, doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
 
const  PdfView = ({item}) => {
  const { id } = useParams();
  
  console.log(id);
  const [currentStep, setCurrentStep] = useState(0);
  const [dialog, setDialog] = useState({
    type: "", // "success" or "error"
    message: "",
    show: false,
  });
  const [formData, setFormData] = useState({
    dateOfAdmission: "",
    admissionFor: "",
        
    particularsOfChild: {
      fullName: "",
      surname: "",
      nameUsedAtHome: "",
      nationality: "",
      dob: "",
      gender: "",
      language: "",
      otherLanguage: "",
      age: "",
      houseNo: "",
      buildingName: "",
      streetName: "",
      city: "",
      pincode: "", // Age field
    },
    particularsOfParents: {
      FatherName: "",
      FatherQualification: "",
      FatherOccupation: "",
      FatherOrganisationName: "",
      FatherSTDCodeRes: "",
      FatherTelRes: "",
      FatherSTDCodeOff: "",
      FatherTelOff: "",
      FatherMobile: "",
      FatherEmail: "",
      MotherName: "",
      MotherQualification: "",
      MotherOccupation: "",
      MotherOrganisationName: "",
      MotherSTDCodeRes: "",
      MotherTelRes: "",
      MotherSTDCodeOff: "",
      MotherTelOff: "",
      MotherMobile: "",
      MotherEmail: "",
    },
    childPersonalBackground: {
      characteristics: [],
      PreviousSchooling: "",
      PreviousSchoolingDetails: "",
      Toilettrained: "",
      Siblings: {
        Brothers: [
          { name: "", age: "" },
          { name: "", age: "" },
          { name: "", age: "" },
        ],
        Sisters: [
          { name: "", age: "" },
          { name: "", age: "" },
          { name: "", age: "" },
        ],
      },
      PreviousKalamKidsDetails: "",
      PreviousKalamKids: "",
      suffered: "",
      surgery: "",
      allergy: "",
      phobias: "",
      phobiasDetails: "",
      medication: "",
      medicationDetails: "",
    },
    // Add medicalRecord for vaccinations
    medicalRecord: {
      BCG: "",
      "DPT (I, II, III)": "",
      "Oral Polio vaccine (OPV)": "",
      Measles: "",
      MMR: "",
      DT: "",
      "HBV-Hepatitis (I, II, III)": "",
      "Hi B (Meningitis-3 doses)": "",
      Chickenpox: "",
      Typhoid: "",
      "Hepatitis A (2 doses)": "",
    },
    Declarationparent: {
      signatureRef: "",
      date: "",
      acknowledgmentName: "",
      acknowledgmentSignatureRef: "",
      volunteerJob: false,
      specialEventsCost: false,
      attendMeetings: false,
    },
  });
  const signatureRef = useRef(null);
  const [isViewMode, setIsViewMode] = useState(false); 

  const acknowledgmentSignatureRef = useRef(null);
  const [loading, setLoading] = useState(false); 
  const options = ["Play Group", "Pre KG", "Junior KG", "Senior KG"];
  const steps = [
    "Particulars of the Child",
    "Particulars of Parents / Guardian",
    "Child’s Personal Background",
    "Medical Record",
    "Declaration ",
    // "Acknowledgment of Paranetal Responsib",
  ];
  const characteristics = [
    "Aggressive",
    "Friendly",
    "Moody",
    "Clumsy",
    "Dependent",
    "Fearful",
    "Quiet",
    "Good-natured",
    "Even-tempered",
    "Impulsive",
    "Shy",
    "Sympathetic",
    "Stubborn",
    "Attentive",
  ];
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);

  const handleChange = (selectedOptions) => {
    setFormData({
      ...formData,
      characteristics: selectedOptions.map((option) => option.value),
    });
  };
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0); // Scroll to the top of the page
    }
  };
  const handlePrint = () => {
    window.print();
  };

  // const handlePrevious = () => {
  //   if (currentStep > 0) {
  //     setCurrentStep(currentStep - 1);
  //     window.scrollTo(0, 0); // Optional: Scroll to the top when going back
  //   }
  // };
//   const showDialog = (type, message) => {
//     setDialog({ type, message, show: true });
// // Automatically close dialog after 3 seconds
//     setTimeout(() => {
//       setDialog({ ...dialog, show: false });
//     }, 4000);
//   };
  // const handleSubmit = async (e) => {
  //   e.preventDefault(); // Prevent default form submission
  
  //   try {
  //     // Capture the signature as an image in base64 format
  //     const parentSignature = signatureRef.current.toDataURL(); // Parent's signature
  //     const acknowledgmentSignature = acknowledgmentSignatureRef.current.toDataURL(); // Acknowledgment signature
  
  //     // Update the formData object to include signature data
  //     const updatedFormData = {
  //       ...formData,
  //       Declarationparent: {
  //         ...formData.Declarationparent,
  //         signatureRef: parentSignature,
  //         acknowledgmentSignatureRef: acknowledgmentSignature,
  //       },
  //     };
  
  //     // Add the form data to Firestore
  //     await addDoc(collection(db, "messages"), updatedFormData);
  
  //     // Show success message
  //     showDialog("success", "Your message has been sent successfully!");
  
  //     // Log the form data (for debugging)
  //     console.log("Form Submitted:", updatedFormData);
  
  //     // Optionally, you can reset the form
  //     setFormData({
  //       dateOfAdmission: "",
  //       admissionFor: "",
  //       particularsOfChild: {
  //         fullName: "",
  //         surname: "",
  //         nameUsedAtHome: "",
  //         nationality: "",
  //         dob: "",
  //         gender: "",
  //         language: "",
  //         otherLanguage: "",
  //         age: "",
  //         houseNo: "",
  //         buildingName: "",
  //         streetName: "",
  //         city: "",
  //         pincode: "",
  //       },
  //       particularsOfParents: {
  //         FatherName: "",
  //         FatherQualification: "",
  //         FatherOccupation: "",
  //         FatherOrganisationName: "",
  //         FatherSTDCodeRes: "",
  //         FatherTelRes: "",
  //         FatherSTDCodeOff: "",
  //         FatherTelOff: "",
  //         FatherMobile: "",
  //         FatherEmail: "",
  //         MotherName: "",
  //         MotherQualification: "",
  //         MotherOccupation: "",
  //         MotherOrganisationName: "",
  //         MotherSTDCodeRes: "",
  //         MotherTelRes: "",
  //         MotherSTDCodeOff: "",
  //         MotherTelOff: "",
  //         MotherMobile: "",
  //         MotherEmail: "",
  //       },
  //       childPersonalBackground: {
  //         characteristics: [],
  //         PreviousSchooling: "",
  //         PreviousSchoolingDetails: "",
  //         Toilettrained: "",
  //         Siblings: {
  //           Brothers: [
  //             { name: "", age: "" },
  //             { name: "", age: "" },
  //             { name: "", age: "" },
  //           ],
  //           Sisters: [
  //             { name: "", age: "" },
  //             { name: "", age: "" },
  //             { name: "", age: "" },
  //           ],
  //         },
  //         PreviousKalamKidsDetails: "",
  //         PreviousKalamKids: "",
  //         suffered: "",
  //         surgery: "",
  //         allergy: "",
  //         phobias: "",
  //         phobiasDetails: "",
  //         medication: "",
  //         medicationDetails: "",
  //       },
  //       medicalRecord: {
  //         BCG: "",
  //         "DPT (I, II, III)": "",
  //         "Oral Polio vaccine (OPV)": "",
  //         Measles: "",
  //         MMR: "",
  //         DT: "",
  //         "HBV-Hepatitis (I, II, III)": "",
  //         "Hi B (Meningitis-3 doses)": "",
  //         Chickenpox: "",
  //         Typhoid: "",
  //         "Hepatitis A (2 doses)": "",
  //       },
  //       Declarationparent: {
  //         signatureRef: "",
  //         date: "",
  //         acknowledgmentName: "",
  //         acknowledgmentSignatureRef: "",
  //         volunteerJob: false,
  //         specialEventsCost: false,
  //         attendMeetings: false,
  //       },
  //     });
  //     setTimeout(() => {
  //       window.location.reload();
  //   }, 3000);
  //   } catch (error) {
  //     // Show error message if something goes wrong
  //     showDialog(
  //       "error",
  //       "Failed to send the message. Please try again later."
  //     );
  //     console.error("FAILED...", error.message);
  //   }
  // };
  // const uploadSignatureToFirebase = async (signatureCanvasRef, fieldName) => {
  //   const signatureData = signatureCanvasRef.current.toDataURL(); // Get the signature as a Base64 image

  //   // Create a storage reference
  //   const storageRef = firebase.storage().ref();
  //   const signatureRef = storageRef.child(`signatures/${fieldName}_${Date.now()}.png`);

  //   // Upload the Base64 image to Firebase
  //   try {
  //     await signatureRef.putString(signatureData, 'data_url');
  //     const signatureUrl = await signatureRef.getDownloadURL(); // Get the URL of the uploaded image
  //     console.log("Signature uploaded successfully: ", signatureUrl);
  //     return signatureUrl;
  //   } catch (error) {
  //     console.error("Error uploading signature: ", error);
  //     return null;
  //   }
  // };

  //   const handleInputChange = (section, field, value) => {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [section]: {
  //         ...prevData[section],
  //         [field]: value,
  //       },
  //     }));
  //   };
  const handleInputChange = (field, subField, value) => {
    setFormData((prev) => {
      const updatedState = { ...prev }; // Make a shallow copy of the previous state
      let currentLevel = updatedState[field]; // Access the target field
  
      // If `subField` is nested, split the path and navigate through it
      const keys = subField.split(".");
      keys.forEach((key, index) => {
        // If it's the last key, update the value
        if (index === keys.length - 1) {
          currentLevel[key] = value;
        } else {
          // Ensure intermediate objects/arrays exist
          if (!currentLevel[key]) {
            currentLevel[key] = isNaN(parseInt(keys[index + 1])) ? {} : [];
          }
          currentLevel = currentLevel[key];
        }
      });
  
      return updatedState;
    });
  };
  

  const handleDobChange = (e) => {
    const dob = e.target.value;
    handleInputChange("particularsOfChild", "dob", dob);

    // Calculate the age
    const age = calculateAge(dob);
    handleInputChange("particularsOfChild", "age", age);
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth();
    if (
      month < birthDate.getMonth() ||
      (month === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };
  const handleVaccinationChange = (vaccine, option) => {
    setFormData((prevData) => ({
      ...prevData,
      medicalRecord: {
        ...prevData.medicalRecord,
        [vaccine]: option, // Update the selected vaccine with the chosen option
      },
    }));
  };

 
  const generatePDF = () => {
    const doc = new jsPDF();
    const input = pdfContentRef.current;
  
    if (!input) {
      console.error("No element found to capture for PDF.");
      return; // Exit if the element is not found
    }
  
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 190; // Adjust width as needed
      const pageHeight = 295; // A4 page height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
  
      let position = 0;
  
      doc.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
  
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
  
      doc.save("admission_form.pdf");
    }).catch((error) => {
      console.error("Error generating PDF:", error);
    });
  };
const pdfContentRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const docRef = doc(db, "messages", id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setFormData(docSnap.data());
            setLoading(false);
            setIsViewMode(true);
          } else {
            console.log("No such document!");
            setLoading(false);
          }
        } catch (error) {
          console.error("Error fetching document: ", error);
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [id]); // Run thi // Fet
  return (
    <>  
{ loading?<Loader/>:( 
   
  <div ref={pdfContentRef} className="max-w-screen-xl poppins-bold mx-auto p-8">
      {/* Logo */}
      <div className="flex flex-col lg:flex-row items-start lg:items-center border-b border-[#16bab1]">
        <img
          src={logo}
          alt="Logo"
          className="h-56 w-72 object-contain mx-auto lg:mx-0"
        />
        <div className="flex flex-col w-full lg:ml-8">
          <h1 className="text-[#16bab1]xl text-[#e84c24] font-semibold mb-4 text-[#16bab1]enter lg:text-left">
            Admission Form
          </h1>
          <div className="flex flex-col lg:flex-row lg:space-x-8">
            <div className="mt-2 w-full lg:w-auto">
              <label
                htmlFor="date"
                className="block text-sm font-medium text-gray-700"
              >
                Date of Admission:
              </label>
              <input
                type="date"
                id="date"
                value={formData.dateOfAdmission}
                className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    dateOfAdmission: e.target.value,
                  }))
                }
              />
            </div>
            <div className="mt-4 mb-3 lg:mt-2 w-full lg:w-auto">
              <label
                htmlFor="admission"
                className="block text-sm font-medium text-gray-700"
              >
                Admission For:
              </label>
              <div className="flex flex-wrap gap-4 mt-2">
                {options.map((option) => (
                  <div
                    key={option}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, admissionFor: option }))
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.admissionFor === option
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form Steps */}
     

      {/* Form Content */}
      <div  className="border border-gray-300 p-6 rounded-lg">
        {/* {renderStepContent()} */}
        <div>
  <h2 className="text-[#16bab1]xl font-semibold mb-4">
    Particulars of the Child
  </h2>

  {/* Form Fields */}
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {/* Full Name */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Full Name:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.fullName}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "fullName",
            e.target.value
          )
        }
      />
    </div>

    {/* Surname */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Surname:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.surname}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "surname",
            e.target.value
          )
        }
      />
    </div>

    {/* Name Used at Home */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Name Used at Home:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.nameUsedAtHome}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "nameUsedAtHome",
            e.target.value
          )
        }
      />
    </div>

    {/* Nationality */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Nationality:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.nationality}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "nationality",
            e.target.value
          )
        }
      />
    </div>

    {/* Date of Birth */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Date of Birth:
      </label>
      <input
        type="date"
        value={formData.particularsOfChild.dob}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={handleDobChange}
      />
    </div>

    {/* Age (Auto-calculated) */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Age:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.age}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "age",
            e.target.value
          )
        } // Allow manual edit
      />
    </div>

    {/* Gender Selection */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Gender:
      </label>
      <div className="flex gap-4 mt-2">
        {["Male", "Female"].map((option) => (
          <div
            key={option}
            onClick={() =>
              handleInputChange(
                "particularsOfChild",
                "gender",
                option
              )
            }
            className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
              formData.particularsOfChild.gender === option
                ? "bg-[#16bab1] text-white"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {option}
          </div>
        ))}
      </div>
    </div>

    {/* House No. */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        House No.:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.houseNo || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "houseNo",
            e.target.value
          )
        }
      />
    </div>

    {/* Name of the Apartment/Building/House */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Apartment/Building Name:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.buildingName || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "buildingName",
            e.target.value
          )
        }
      />
    </div>

    {/* Street Name */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Street Name:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.streetName || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "streetName",
            e.target.value
          )
        }
      />
    </div>

    {/* Town/City */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Town/City:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.city || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "city",
            e.target.value
          )
        }
      />
    </div>

    {/* Pincode */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Pincode:
      </label>
      <input
        type="text"
        value={formData.particularsOfChild.pincode || ""}
        className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
        onChange={(e) =>
          handleInputChange(
            "particularsOfChild",
            "pincode",
            e.target.value
          )
        }
      />
    </div>

    {/* Language(s) Spoken at Home */}
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700">
        Language(s) Spoken at Home
      </label>
      <div className="flex gap-4 mt-2">
        {["English", "Tamil", "Other"].map((option) => (
          <div
            key={option}
            onClick={() =>
              handleInputChange(
                "particularsOfChild",
                "language",
                option
              )
            }
            className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
              formData.particularsOfChild.language === option
                ? "bg-[#16bab1] text-white"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {option}
          </div>
        ))}
      </div>

      {/* Conditionally render input field for "Other" */}
      {formData.particularsOfChild.language === "Other" && (
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            Please specify:
          </label>
          <input
            type="text"
            value={formData.particularsOfChild.otherLanguage || ""}
            className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
            onChange={(e) =>
              handleInputChange(
                "particularsOfChild",
                "otherLanguage",
                e.target.value
              )
            }
          />
        </div>
      )}
    </div>
  </div>
</div>
<>
            <div className="mb-4">
              <h2 className="text-[#16bab1]xl font-semibold mb-4">Father / Guardian</h2>
              <div className="grid grid-cols-2 gap-4 items-start">
                {/* Name */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents.FatherName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "FatherName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Educational Qualification */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Educational Qualification:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Undergraduate", "Graduate", "Postgraduate"].map(
                      (option) => (
                        <div
                          key={option}
                          onClick={() =>
                            handleInputChange(
                              "particularsOfParents",
                              "FatherQualification",
                              option
                            )
                          }
                          className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                            formData.particularsOfParents
                              .FatherQualification === option
                              ? "bg-[#16bab1] text-white"
                              : "bg-white text-gray-700 border-gray-300"
                          }`}
                        >
                          {option}
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Occupation */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Occupation:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Service", "Business", "Public Service"].map((option) => (
                      <div
                        key={option}
                        onClick={() =>
                          handleInputChange(
                            "particularsOfParents",
                            "FatherOccupation",
                            option
                          )
                        }
                        className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                          formData.particularsOfParents.FatherOccupation ===
                          option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                        }`}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Name of the Organisation */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name of the Organisation:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents.FatherOrganisationName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "FatherOrganisationName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Tel No. */}
                <div className="col-span-4 lg:col-span-2">
      <label className="block text-sm font-medium text-gray-700">
        Tel No.:
      </label>
      <div className="grid grid-cols-4 gap-2 mt-2">
        <input
          type="text"
          placeholder="[STD]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherSTDCodeRes || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherSTDCodeRes",
              e.target.value
            )
          }
        />
        <input
          type="text"
          placeholder="[Res]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherTelRes || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherTelRes",
              e.target.value
            )
          }
        />
        <input
          type="text"
          placeholder="[STD]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherSTDCodeOff || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherSTDCodeOff",
              e.target.value
            )
          }
        />
        <input
          type="text"
          placeholder="[Off]"
          className="px-4 py-2 border border-gray-300 rounded-md w-full"
          value={formData?.particularsOfParents?.FatherTelOff || ""}
          onChange={(e) =>
            handleInputChange(
              "particularsOfParents",
              "FatherTelOff",
              e.target.value
            )
          }
        />
      </div>
    </div>

    {/* Mobile */}
    <div className="col-span-4 lg:col-span-1">
      <label className="block text-sm font-medium text-gray-700">
        Mobile:
      </label>
      <input
        type="text"
        placeholder="[Mob]"
        className="mt-2 px-4 py-2 border border-gray-300 rounded-md w-full"
        value={formData?.particularsOfParents?.FatherMobile || ""}
        onChange={(e) =>
          handleInputChange(
            "particularsOfParents",
            "FatherMobile",
            e.target.value
          )
        }
      />
    </div>


                {/* Email Address */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Email Address:
                  </label>
                  <input
                    type="email"
                    value={formData.particularsOfParents.FatherEmail}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "FatherEmail",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
            <div>
              <h2 className="text-[#16bab1]xl font-semibold mb-4">Mother / Guardian</h2>
              <div className="grid grid-cols-2 gap-4 items-start">
                {/* Name */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents.MotherName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "MotherName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Educational Qualification */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Educational Qualification:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Undergraduate", "Graduate", "Postgraduate"].map(
                      (option) => (
                        <div
                          key={option}
                          onClick={() =>
                            handleInputChange(
                              "particularsOfParents",
                              "MotherQualification",
                              option
                            )
                          }
                          className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                            formData.particularsOfParents
                              .MotherQualification === option
                              ? "bg-[#16bab1] text-white"
                              : "bg-white text-gray-700 border-gray-300"
                          }`}
                        >
                          {option}
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Occupation */}
                <div className="col-span-4 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Occupation:
                  </label>
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {["Service", "Business", "Public Service"].map((option) => (
                      <div
                        key={option}
                        onClick={() =>
                          handleInputChange(
                            "particularsOfParents",
                            "MotherOccupation",
                            option
                          )
                        }
                        className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-[#16bab1]enter ${
                          formData.particularsOfParents.MotherOccupation ===
                          option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                        }`}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Name of the Organisation */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Name of the Organisation:
                  </label>
                  <input
                    type="text"
                    value={formData.particularsOfParents.MotherOrganisationName}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "MotherOrganisationName",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Tel No. */}
                <div className="col-span-4 lg:col-span-2">
  <label className="block text-sm font-medium text-gray-700">
    Tel No.:
  </label>
  <div className="grid grid-cols-4 gap-2 mt-2">
    {/* STD Code for Residential */}
    <input
      type="text"
      placeholder="[STD]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherSTDCodeRes || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherSTDCodeRes",
          e.target.value
        )
      }
    />
    {/* Residential Tel No */}
    <input
      type="text"
      placeholder="[Res]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherTelRes || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherTelRes",
          e.target.value
        )
      }
    />
    {/* STD Code for Office */}
    <input
      type="text"
      placeholder="[STD]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherSTDCodeOff || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherSTDCodeOff",
          e.target.value
        )
      }
    />
    {/* Office Tel No */}
    <input
      type="text"
      placeholder="[Off]"
      className="px-4 py-2 border border-gray-300 rounded-md w-full"
      value={formData?.particularsOfParents?.MotherTelOff || ""}
      onChange={(e) =>
        handleInputChange(
          "particularsOfParents",
          "MotherTelOff",
          e.target.value
        )
      }
    />
  </div>
</div>

{/* Mobile */}
<div className="col-span-4 lg:col-span-1">
  <label className="block text-sm font-medium text-gray-700">
    Mobile:
  </label>
  <input
    type="text"
    placeholder="[Mob]"
    className="mt-2 px-4 py-2 border border-gray-300 rounded-md w-full"
    value={formData?.particularsOfParents?.MotherMobile || ""}
    onChange={(e) =>
      handleInputChange(
        "particularsOfParents",
        "MotherMobile",
        e.target.value
      )
    }
  />
</div>


                {/* Email Address */}
                <div className="col-span-4 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Email Address:
                  </label>
                  <input
                    type="email"
                    value={formData.particularsOfParents.MotherEmail}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange(
                        "particularsOfParents",
                        "MotherEmail",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
  {/* Full width MultiSelect component */}
  <div className="col-span-3">
    <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="characteristics">
      Please select the characteristics that generally describe your child:
    </label>
    <MultiSelect
      options={characteristics && characteristics.length > 0
        ? characteristics.map((characteristic) => ({
            label: characteristic,
            value: characteristic,
          }))
        : []}
      value={formData.characteristics && formData.characteristics.length > 0
        ? formData.characteristics.map((characteristic) => ({
            label: characteristic,
            value: characteristic,
          }))
        : []}
      onChange={handleChange}
      labelledBy="Select Characteristics"
      className="bg-white border border-gray-300 rounded-lg shadow-sm w-full p-3 focus:outline-none focus:ring-2 focus:ring-[#e84c24]"
    />
  </div>

  {/* Previous Schooling */}
  <div className="mb-4 md:col-span-1 col-span-2">
    <label className="block text-sm font-medium text-gray-700">
      Previous Schooling
    </label>
    <div className="flex gap-4 mt-2">
      {["Yes", "No"].map((option) => (
        <div
          key={option}
          onClick={() =>
            handleInputChange("childPersonalBackground", "PreviousSchooling", option)
          }
          className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-full ${
            formData.childPersonalBackground.PreviousSchooling === option
              ? "bg-[#16bab1] text-white"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {option}
        </div>
      ))}
    </div>
  </div>

  {/* If "Yes", show the details input for Previous Schooling */}
  {formData.childPersonalBackground.PreviousSchooling === "Yes" && (
    <div className="mb-4 md:col-span-1 col-span-2">
      <label className="block text-sm font-medium text-gray-700">
        If yes, please specify:
      </label>
      <input
        type="text"
        value={formData.childPersonalBackground.PreviousSchoolingDetails}
        onChange={(e) =>
          handleInputChange("childPersonalBackground", "PreviousSchoolingDetails", e.target.value)
        }
        className="mt-2 px-4 py-2 w-full border border-gray-300 rounded-md"
        placeholder="Enter details"
      />
    </div>
  )}

  {/* Toilet trained question */}
  <div className="mb-4 md:col-span-1 col-span-2">
    <label className="block text-sm font-medium text-gray-700">
      • Is your child Toilet trained?
    </label>
    <div className="flex gap-4 mt-2">
      {["Yes", "No"].map((option) => (
        <div
          key={option}
          onClick={() =>
            handleInputChange("childPersonalBackground", "Toilettrained", option)
          }
          className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-full ${
            formData.childPersonalBackground.Toilettrained === option
              ? "bg-[#16bab1] text-white"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {option}
        </div>
      ))}
    </div>
  </div>

  {/* Siblings Information */}
  <div className="col-span-3 gap-4">
    <label className="block text-sm font-medium text-gray-700">
      • How many siblings does the child have?
    </label>

    <div className="col-span-3">
      <label className="block text-sm font-medium text-gray-700">
        Brothers (mention age):
      </label>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`brother-${index}`} className="flex gap-4 mt-2">
          <input
            type="text"
            value={formData.childPersonalBackground.Siblings.Brothers[index]?.name || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Brothers.${index}.name`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Brother ${index + 1} Name`}
          />
          <input
            type="text"
            value={formData.childPersonalBackground.Siblings.Brothers[index]?.age || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Brothers.${index}.age`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Brother ${index + 1} Age`}
          />
        </div>
      ))}
    </div>

    <div className="col-span-3 mt-4">
      <label className="block text-sm font-medium text-gray-700">
        Sisters (mention age):
      </label>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`sister-${index}`} className="flex gap-4 mt-2">
          <input
            type="text"
            value={formData.childPersonalBackground.Siblings.Sisters[index]?.name || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Sisters.${index}.name`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Sister ${index + 1} Name`}
          />
          <input
            type="text"
            value={formData.childPersonalBackground.Siblings.Sisters[index]?.age || ""}
            onChange={(e) =>
              handleInputChange("childPersonalBackground", `Siblings.Sisters.${index}.age`, e.target.value)
            }
            className="px-4 py-2 w-full border border-gray-300 rounded-md"
            placeholder={`Sister ${index + 1} Age`}
          />
        </div>
      ))}
    </div>
  </div>

  {/* Has any of the child’s kin attended Kalam Kids before */}
  <div className="mb-4 col-span-3">
    <label className="block text-sm font-medium text-gray-700">
      Has any of the child’s kin attended Kalam Kids before?
    </label>
    <div className="flex gap-4 mt-2">
      {["Yes", "No"].map((option) => (
        <div
          key={option}
          onClick={() =>
            handleInputChange("childPersonalBackground", "PreviousKalamKids", option)
          }
          className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-full ${
            formData.childPersonalBackground.PreviousKalamKids === option
              ? "bg-[#16bab1] text-white"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {option}
        </div>
      ))}
    </div>
  </div>

  {/* If "Yes", show the details input for Previous Kalam Kids */}
  {formData.childPersonalBackground.PreviousKalamKids === "Yes" && (
    <div className="mb-4 col-span-3">
      <label className="block text-sm font-medium text-gray-700">
        If yes, which year:
      </label>
      <input
        type="text"
        value={formData.childPersonalBackground.PreviousKalamKidsDetails}
        onChange={(e) =>
          handleInputChange("childPersonalBackground", "PreviousKalamKidsDetails", e.target.value)
        }
        className="mt-2 px-4 py-2 w-full border border-gray-300 rounded-md"
        placeholder="Enter details"
      />
    </div>
  )}
</div>
<div>
          <h2>Vaccination Details</h2>
          <div className="overflow-x-auto mt-4">
            <table className="min-w-full table-auto border-collapse border border-gray-300">
              <thead>
                <tr className="bg-[#16bab1] text-white font-semibold">
                  <th className="px-4 py-2 border text-left">S.No.</th>
                  <th className="px-4 py-2 border text-left">Vaccination</th>
                  <th className="px-4 py-2 border text-left">Age</th>
                  <th className="px-4 py-2 border text-[#16bab1]enter">Yes / No</th>
                </tr>
              </thead>
              <tbody className="font-medium">
                {[
                  { vaccine: "BCG", age: "0-2 weeks" },
                  { vaccine: "DPT (I, II, III)", age: "6-24 weeks" },
                  { vaccine: "Oral Polio vaccine (OPV)", age: "6 doses" },
                  { vaccine: "Measles", age: "8-9 months" },
                  { vaccine: "MMR", age: "15-18 months" },
                  { vaccine: "DT", age: "4-6 years" },
                  { vaccine: "HBV-Hepatitis (I, II, III)", age: "Up to 24 months" },
                  { vaccine: "Hi B (Meningitis-3 doses)", age: "Under 1 year" },
                  { vaccine: "Chickenpox", age: "After 1 year of age" },
                  { vaccine: "Typhoid", age: "After 2 years" },
                  { vaccine: "Hepatitis A (2 doses)", age: "After 1 year of age" },
                ].map((vaccination, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                  >
                    <td className="px-4 py-2 border text-[#16bab1]enter">{index + 1}</td>
                    <td className="px-4 py-2 border">{vaccination.vaccine}</td>
                    <td className="px-4 py-2 border">{vaccination.age}</td>
                    <td className="px-4 py-2 border text-[#16bab1]enter">
                      <div className="flex gap-4 justify-center">
                        {["Yes", "No"].map((option) => (
                          <div
                            key={option}
                            onClick={() =>
                              handleVaccinationChange(vaccination.vaccine, option)
                            }
                            className={`cursor-pointer capitalize px-4 py-2 rounded-full border text-[#16bab1]enter w-16 ${
                              formData.medicalRecord[vaccination.vaccine] === option
                                ? "bg-[#16bab1] text-white"
                                : "bg-white text-gray-700 border-gray-300"
                            }`}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-4 text-sm">
            <p>
              <strong className="text-black font-semibold">Note:</strong>
            </p>
            <ul className="list-disc list-inside ml-4 font-medium">
              <li className="text-gray-600">Vaccines (1) to (7) are compulsory.</li>
              <li className="text-gray-600">Vaccines (8) to (11) are optional but recommended.</li>
            </ul>
          </div>
        
          <div className="mt-6">
            <h3 className="text-lg font-medium text-gray-700">
              II. History of Past Illness
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
              {/* Specific Ailments */}
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Specific ailments suffered in the past:
                </label>
                <input
                  type="text"
                  value={formData.medicalRecord.suffered || ""}
                  className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                  onChange={(e) =>
                    handleInputChange("medicalRecord", "suffered", e.target.value)
                  }
                />
              </div>
              {/* Surgery */}
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Surgery undergone (if any):
                </label>
                <input
                  type="text"
                  value={formData.medicalRecord.surgery || ""}
                  className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                  onChange={(e) =>
                    handleInputChange("medicalRecord", "surgery", e.target.value)
                  }
                />
              </div>
              {/* Allergy */}
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Allergy (if any):
                </label>
                <input
                  type="text"
                  value={formData.medicalRecord.allergy || ""}
                  className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                  onChange={(e) =>
                    handleInputChange("medicalRecord", "allergy", e.target.value)
                  }
                />
              </div>
            </div>
        
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700">
                Does your child suffer from any phobias?
              </label>
              <div className="flex gap-4 mt-2">
                {["Yes", "No"].map((option) => (
                  <div
                    key={option}
                    onClick={() =>
                      handleInputChange("medicalRecord", "phobias", option)
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.medicalRecord.phobias === option
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
              {formData.medicalRecord.phobias === "Yes" && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Please specify:
                  </label>
                  <input
                    type="text"
                    value={formData.medicalRecord.phobiasDetails || ""}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange("medicalRecord", "phobiasDetails", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
        
            {/* Regular Medication */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700">
                Is the child presently on any regular medication?
              </label>
              <div className="flex gap-4 mt-2">
                {["Yes", "No"].map((option) => (
                  <div
                    key={option}
                    onClick={() =>
                      handleInputChange("medicalRecord", "medication", option)
                    }
                    className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${
                      formData.medicalRecord.medication === option
                        ? "bg-[#16bab1] text-white"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
              {formData.medicalRecord.medication === "Yes" && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Please specify:
                  </label>
                  <input
                    type="text"
                    value={formData.medicalRecord.medicationDetails || ""}
                    className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md"
                    onChange={(e) =>
                      handleInputChange("medicalRecord", "medicationDetails", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <>
      <div className="max-w-6xl mx-auto bg-white  p-2 mt-3 rounded-lg shadow-md border border-[#16bab1]">
        {/* Declaration Section */}
        <h2 className="text-md py-2 font-semibold text-[#16bab1]enter bg-[#16bab1] text-white mb-4">
          Declaration of parent / Guardian
        </h2>
        <div className="mt-6">
          <p className="text-md font-medium text-gray-700 mb-6 leading-relaxed">
            I declare that the information given is correct and complete and I have not withheld any information. I agree to entrust my child under the care of the staff at{" "}
            <span className="font-semibold">Kalam Kids</span>. I am aware that the fee once paid is{" "}
            <span className="font-semibold">non-transferable</span> and <span className="font-semibold">non-refundable</span> under any circumstances. I have read through the{" "}
            <span className="font-semibold">Kalam Kids</span> pre-school policies and am in agreement with the said policies.
          </p>

          {/* Signature Field */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Parent's Signature:
            </label>
            {isViewMode ? (
              <img
                src={formData.Declarationparent.signatureRef}
                alt="Parent's Signature"
                className="border border-gray-300 rounded-md"
                style={{ width: '100%', height: 'auto' }} // Adjust as needed
              />
            ) : (
              <div className="border border-gray-300 rounded-md overflow-hidden">
                <ReactSignatureCanvas
                  penColor="black"
                  canvasProps={{
                    width: 1024,
                    height: 150,
                    className: "sigCanvas",
                  }}
                  ref={signatureRef}
                />
              </div>
            )}
            {!isViewMode && (
              <button
                className="mt-2 text-sm text-[#e84c24] underline hover:text-[#e84c24]"
                onClick={() => signatureRef.current?.clear()}
                type="button"
              >
                Clear Signature
              </button>
            )}
          </div>

          {/* Date Field */}
          <div className="mt-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Date:
            </label>
            <input
              type="date"
              value={formData.Declarationparent.date || ""}
              className="mt-2 block px-4 py-2 w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              onChange={(e) =>
                handleInputChange(
                  "Declarationparent",
                  "date",
                  e.target.value
                )
              }
              disabled={isViewMode} // Disable input in view mode
            />
          </div>
        </div>

        {/* Acknowledgment Section */}
        <div className="mt-8">
          <h2 className="text-md py-2 font-semibold text-[#16bab1]enter bg-[#16bab1] text-white mb-4">
            Acknowledgment of Parental Responsibility
          </h2>
          <p className="text-sm text-gray-600 mb-6 leading-relaxed">
            I,{" "}
            <input
              type="text"
              value={formData.Declarationparent.acknowledgmentName || ""}
              onChange={(e) =>
                handleInputChange(
                  "Declarationparent",
                  "acknowledgmentName",
                  e.target.value
                )
              }
              className="border-b border-gray-400 focus:border-[#16bab1] px-2 py-1 outline-none"
              disabled={isViewMode} // Disable input in view mode
            />
            , hereby acknowledge that I understand the expectations to participate in the smooth running of my children’s Play School as follows:
          </p>
          <div className="text-sm text-gray-600 mb-6">
  <label className="block mb-4">
    <input
      type="checkbox"
      name="volunteerJob"
      className="mr-2"
      checked={formData.Declarationparent.volunteerJob} // Bind the state value
      onChange={(e) =>
        handleInputChange(
          "Declarationparent",
          "volunteerJob",
          e.target.value
        )
      }
    />
    I am required to take at least one job from the Volunteer Job list and perform it to the best of my ability.
  </label>
  <label className="block mb-4">
    <input
      type="checkbox"
      name="specialEventsCost"
      className="mr-2"
      checked={formData.Declarationparent.specialEventsCost}
      onChange={(e) =>
        handleInputChange(
          "Declarationparent",
          "specialEventsCost",
          e.target.value
        )
      }
    />
    I am required to pay for my children’s special events and field trip costs.
  </label>
  <label className="block mb-4">
    <input
      type="checkbox"
      name="attendMeetings"
      className="mr-2"
      checked={formData.Declarationparent.attendMeetings}
      onChange={(e) =>
        handleInputChange(
          "Declarationparent",
          "attendMeetings",
          e.target.value
        )
      }
    />
    I am required to attend Annual General Meetings.
  </label>
</div>



          {/* Acknowledgment Signature Field */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Acknowledgment Signature:
            </label>
            {isViewMode ? (
              <img
                src={formData.Declarationparent.acknowledgmentSignatureRef}
                alt="Acknowledgment Signature"
                className="border border-gray-300 rounded-md"
                style={{ width: '100%', height: 'auto' }} // Adjust as needed
              />
            ) : (
              <div className="border border-gray-300 rounded-md overflow-hidden">
                <ReactSignatureCanvas
                  penColor="black"
                  canvasProps={{
                    width: 1000,
                    height: 150,
                    className: "sigCanvas",
                  }}
                  ref={acknowledgmentSignatureRef}
                />
              </div>
            )}
            {!isViewMode && (
              <button
                className="mt-2 text-sm text-[#e84c24] underline hover:text-[#e84c24]"
                onClick={() => acknowledgmentSignatureRef.current?.clear()}
                type="button"
              >
                Clear Signature
              </button>
            )}
          </div>
        </div>
      </div>
    </>
        {/* Navigation Buttons */}
        {/* <button onClick={generatePDF} className="mt-4 bg-[#16bab1] text-white px-4 py-2 rounded">
            Download PDF
          </button> */}
            <button onClick={handlePrint} className="mt-4 bg-[#16bab1] text-white px-4 py-2 rounded">
            Print
          </button>
      </div>
    </div> 

  )}

    </>
  );
};

export default  PdfView;
